<template>
  <VField
    class="mb-6"
    error-class="mt-1"
    :error="validationError"
  >
    <VSelect
      :class="$style['select']"
      :options="options"
      :valid="isValid"
      :invalid="$v.date.$error"
      :optional="optional"
      :disabled="disabled"
      :placeholder="label"
      theme="white"
      v-model="date"
      v-on="$listeners"
      @change="onChange"
    />
  </VField>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

import {
  VField,
  VSelect
} from '@c/base'

export default {
  components: {
    VField,
    VSelect
  },

  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    options: {
      type: [Array, Object],
      required: true
    },
    optional: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      date: this.value
    }
  },

  watch: {
    value: function (newVal) {
      this.date = newVal
    }
  },

  computed: {
    validationError () {
      if (this.$v.date.$error && !this.$v.date.required) {
        return this.$t('validate.required', { attribute: this.$t('attributes.date') })
      }

      return ''
    },

    isValid () {
      return !this.$v.date.$error &&
             this.$v.date.required
    }
  },

  methods: {
    onChange () {
      this.$v.date.$touch()

      this.$emit('input', this.date)
    }
  },

  validations: {
    date: {
      required
    }
  }
}
</script>

<style lang="scss" module>
.select {
  height: 40px;
}
</style>
